import { useParams } from '@reach/router'
import { TFunction } from 'i18next'
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import axios from '../../axios'
import { ENDPOINTS } from '../../constants'
import Layout from '../../layouts/defaultLayout'
import CHRSectionContainer from '../sectionContainer'
import SEO from '../seo'
import Listing from './listing'
import { styles } from './styles'

interface FolderPageProps {
  t: TFunction
}

const FolderPage = ({ t }: FolderPageProps) => {
  const classes = styles()

  const params = useParams()
  const folderId = params.folderId

  const [seoMeta, setSeoMeta] = useState({
    title: t('shoppingBoard.metaTitle'),
    description: t('shoppingBoard.metaDescription'),
    image: undefined,
  })

  useEffect(() => {
    const getFolderMetadata = async () => {
      const {
        data: { data },
      } = await axios.get(ENDPOINTS.getSBFolderMeta.replace(':id', folderId))
      setSeoMeta(prev => ({
        ...prev,
        title: data.metadata.name
          ? `${data.metadata.name} | ${prev.title}`
          : prev.title,
        description: data.metadata.description
          ? `${data.metadata.description} | ${prev.description}`
          : prev.description,
        image: data.metadata.image || prev.image,
      }))
    }

    if (folderId) {
      getFolderMetadata()
    }
  }, [folderId])

  return (
    <>
      <Layout>
        <SEO
          title={seoMeta.title}
          description={seoMeta.description}
          image={seoMeta.image}
        />
        <CHRSectionContainer customStyle={classes.wrapper}>
          <Listing />
        </CHRSectionContainer>
      </Layout>
    </>
  )
}

export default withTranslation()(FolderPage)
